module.exports = __webpack_public_path__ + "static/media/Ned Stark 1.a49cd3ee.jpg";